unit uFrmMain;

interface

uses
  SysUtils, WEBLib.Forms, Classes, WEBLib.Graphics, WEBLib.Dialogs,
  WEBLib.StdCtrls, WEBLib.Controls, WEBLib.ExtCtrls,
  uSubForm1, uSubForm2, Unit1, Unit2, Unit3, Unit4, WEBLib.Buttons,
  WEBLib.Imaging.jpeg, WEBLib.DBCtrls, DB, WEBLib.DB, WEBLib.CDS, WEBLib.Grids,
  WEBLib.TMSFNCTypes, WEBLib.TMSFNCUtils, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCTrackBar, WEBLib.TMSFNCRangeSlider,
  WEBLib.JQCtrls, WEBLib.Imaging.pngimage;

type
  TFrmMain = class(TForm)
    txtSampleText: TEdit;
    HostPanel: TPanel;
    WebGroupBox1: TGroupBox;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebEdit1: TEdit;
    WebImageControl1: TImageControl;
    WebPanel1: TPanel;
    WebSplitter1: TSplitter;
    WebBitBtn3: TBitBtn;
    WebBitBtn4: TBitBtn;
    WebBitBtn5: TBitBtn;
    WebBitBtn6: TBitBtn;
    WebBitBtn7: TBitBtn;
    WebBitBtn8: TBitBtn;
    WebLabel1: TLabel;
    WebEdit2: TEdit;
    WebLabel4: TLabel;
    WebEdit3: TEdit;
    WebLabel5: TLabel;
    WebEdit4: TEdit;
    WebLabel6: TLabel;
    WebEdit5: TEdit;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebEdit6: TEdit;
    WebLabel12: TLabel;
    WebEdit7: TEdit;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebEdit10: TEdit;
    WebEdit11: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebLabel13: TLabel;
    WebEdit14: TEdit;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebEdit15: TEdit;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebButton1: TButton;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebEdit16: TEdit;
    WebEdit17: TEdit;
    WebEdit18: TEdit;
    WebEdit19: TEdit;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebEdit20: TEdit;
    WebEdit21: TEdit;
    WebLabel25: TLabel;
    procedure btCreateSubF1Click(Sender: TObject);
    procedure btRemoveSubFormClick(Sender: TObject);
    procedure btTransferSetClick(Sender: TObject);
    procedure btCreateSubF2Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btTransferGetClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure comboStateChange(Sender: TObject);
    procedure comboCountryChange(Sender: TObject);
    procedure WebBitBtn1Click(Sender: TObject);
    procedure WebImageControl1Click(Sender: TObject);
    procedure WebBitBtn2Click(Sender: TObject);
    procedure WebBitBtn3Click(Sender: TObject);
    procedure WebBitBtn4Click(Sender: TObject);
    procedure WebBitBtn5Click(Sender: TObject);
    procedure WebBitBtn6Click(Sender: TObject);
    procedure WebBitBtn7Click(Sender: TObject);
    procedure WebBitBtn8Click(Sender: TObject);
    procedure WebBitBtn9Click(Sender: TObject);
    procedure WebBitBtn10Click(Sender: TObject);
  protected
    procedure LoadDFMValues; override;
  public
    frm: TForm;
    procedure ValidateForm; overload;
  end;

    TCountry = class(TPersistent)
  private
    FName: string;
    FCode: string;
    FContinent: string;
  public
    property Name: string read FName write FName;
    property Code: string read FCode write FCode;
    property Continent: string read FContinent write FContinent;
  end;

var
  FrmMain: TFrmMain;


implementation



procedure TFrmMain.ValidateForm;
var
  edvalid, edinvalid: string;
begin
  edvalid := 'form-control';
  edinvalid := 'form-control is-invalid';

end;


procedure TFrmMain.btCreateSubF1Click(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm1.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.btRemoveSubFormClick(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
//    if Assigned(frm) and (frm is Unit1) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

//  frm :=  TUnit1.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.btTransferSetClick(Sender: TObject);
begin
  if Assigned(frm) and (frm is TSubForm1) then
end;

procedure TFrmMain.comboCountryChange(Sender: TObject);
var
  cc: string;
begin

end;

procedure TFrmMain.comboStateChange(Sender: TObject);
begin
ValidateForm;
end;

procedure TFrmMain.btCreateSubF2Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm2.CreateNew(HostPanel.ElementID, nil);
end;

procedure TFrmMain.btTransferGetClick(Sender: TObject);
begin
  if Assigned(frm) and (frm is TSubForm1) then
end;

procedure TFrmMain.WebBitBtn10Click(Sender: TObject);
var   AF : String;
begin

end;

procedure TFrmMain.WebBitBtn1Click(Sender: TObject);
var    edvalid, edinvalid: string;

begin

end;

procedure TFrmMain.WebBitBtn2Click(Sender: TObject);
var  im   : Integer;
     L    : String;
begin

end;

procedure TFrmMain.WebBitBtn3Click(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
   //    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm1.CreateNew(HostPanel.ElementID, @AfterCreate);
  WebBitBtn4.Enabled:=True;
  WebBitBtn4.Visible:=True;
end;

procedure TFrmMain.WebBitBtn4Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TSubForm1) then
  end;

begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TSubForm2.CreateNew(HostPanel.ElementID, nil);
  WebBitBtn5.Enabled:=True;
  WebBitBtn5.Visible:=True;
end;

procedure TFrmMain.WebBitBtn5Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm1) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm1.CreateNew(HostPanel.ElementID, @AfterCreate);
  WebBitBtn6.Enabled:=True;
  WebBitBtn6.Visible:=True;
end;

procedure TFrmMain.WebBitBtn6Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm2) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm2.CreateNew(HostPanel.ElementID, @AfterCreate);
  WebBitBtn7.Enabled:=True;
  WebBitBtn7.Visible:=True;
end;

procedure TFrmMain.WebBitBtn7Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm3) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm3.CreateNew(HostPanel.ElementID, @AfterCreate);
//  WebBitBtn8.Visible:=True;
end;

procedure TFrmMain.WebBitBtn8Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm4) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

 frm :=  TForm4.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.WebBitBtn9Click(Sender: TObject);
var   IL     : Integer;
begin
end;

procedure TFrmMain.WebButton1Click(Sender: TObject);
begin
// ShowMessage('TO JEST = '+WebEdit12.Text);
end;


procedure TFrmMain.WebButton2Click(Sender: TObject);
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm4) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm4.CreateNew(HostPanel.ElementID, @AfterCreate);
end;

procedure TFrmMain.WebButton3Click(Sender: TObject);

  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(frm) and (frm is TForm3) then
  end;
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TForm3.CreateNew(HostPanel.ElementID, @AfterCreate);
end;


procedure TFrmMain.WebFormCreate(Sender: TObject);
var
  bt, ed, lb, co: string;
begin
  //bootstrap class
  frm := nil;
end;

procedure TFrmMain.WebImageControl1Click(Sender: TObject);
begin
  // destroy possible old form
  if Assigned(frm) then
    frm.Close;

  frm :=  TFrmMain.CreateNew();
end;

procedure TFrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  HostPanel := TPanel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  txtSampleText := TEdit.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit11 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebEdit16 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit19 := TEdit.Create(Self);
  WebEdit20 := TEdit.Create(Self);
  WebEdit21 := TEdit.Create(Self);
  WebBitBtn3 := TBitBtn.Create(Self);
  WebBitBtn4 := TBitBtn.Create(Self);
  WebBitBtn5 := TBitBtn.Create(Self);
  WebBitBtn6 := TBitBtn.Create(Self);
  WebBitBtn7 := TBitBtn.Create(Self);
  WebBitBtn8 := TBitBtn.Create(Self);
  WebEdit15 := TEdit.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebSplitter1 := TSplitter.Create(Self);

  HostPanel.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  txtSampleText.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit11.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebEdit16.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit19.BeforeLoadDFMValues;
  WebEdit20.BeforeLoadDFMValues;
  WebEdit21.BeforeLoadDFMValues;
  WebBitBtn3.BeforeLoadDFMValues;
  WebBitBtn4.BeforeLoadDFMValues;
  WebBitBtn5.BeforeLoadDFMValues;
  WebBitBtn6.BeforeLoadDFMValues;
  WebBitBtn7.BeforeLoadDFMValues;
  WebBitBtn8.BeforeLoadDFMValues;
  WebEdit15.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebSplitter1.BeforeLoadDFMValues;
  try
    Name := 'FrmMain';
    Left := 0;
    Top := 0;
    Width := 976;
    Height := 730;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    HostPanel.SetParentComponent(Self);
    HostPanel.Name := 'HostPanel';
    HostPanel.Left := 0;
    HostPanel.Top := 270;
    HostPanel.Width := 976;
    HostPanel.Height := 460;
    HostPanel.Align := alBottom;
    HostPanel.BorderColor := clSilver;
    HostPanel.BorderStyle := bsSingle;
    HostPanel.Color := clWhite;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 976;
    WebPanel1.Height := 257;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := clSilver;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.Caption := 'WebPanel1';
    WebPanel1.ChildOrder := 9;
    WebImageControl1.SetParentComponent(WebPanel1);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 0;
    WebImageControl1.Top := 0;
    WebImageControl1.Width := 976;
    WebImageControl1.Height := 125;
    WebImageControl1.Align := alTop;
    WebImageControl1.ChildOrder := 8;
    SetEvent(WebImageControl1, Self, 'OnClick', 'WebImageControl1Click');
    WebImageControl1.Picture.LoadFromFile('uFrmMain.WebPanel1.WebImageControl1.Picture.png');
    WebGroupBox1.SetParentComponent(WebPanel1);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 0;
    WebGroupBox1.Top := 125;
    WebGroupBox1.Width := 976;
    WebGroupBox1.Height := 65;
    WebGroupBox1.Align := alTop;
    WebGroupBox1.Caption := 'Dane elektrowni';
    WebGroupBox1.ChildOrder := 12;
    WebGroupBox1.Color := clMoneyGreen;
    WebLabel2.SetParentComponent(WebGroupBox1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 11;
    WebLabel2.Top := 20;
    WebLabel2.Width := 54;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Lokalizacja ';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := 13;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.ParentFont := False;
    WebLabel3.SetParentComponent(WebGroupBox1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 110;
    WebLabel3.Top := 20;
    WebLabel3.Width := 28;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Uzysk';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := 13;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.ParentFont := False;
    WebLabel1.SetParentComponent(WebGroupBox1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 231;
    WebLabel1.Top := 20;
    WebLabel1.Width := 71;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Zu'#380'ycie energii';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := 13;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.ParentFont := False;
    WebLabel4.SetParentComponent(WebGroupBox1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 332;
    WebLabel4.Top := 20;
    WebLabel4.Width := 61;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Koszt energii';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := 13;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.ParentFont := False;
    WebLabel5.SetParentComponent(WebGroupBox1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 416;
    WebLabel5.Top := 20;
    WebLabel5.Width := 82;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Produkcja energii';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := 13;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.ParentFont := False;
    WebLabel6.SetParentComponent(WebGroupBox1);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 523;
    WebLabel6.Top := 20;
    WebLabel6.Width := 90;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Warto'#347#263' inwestycji';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := 13;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.ParentFont := False;
    WebLabel7.SetParentComponent(WebGroupBox1);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 382;
    WebLabel7.Top := 43;
    WebLabel7.Width := 22;
    WebLabel7.Height := 11;
    WebLabel7.Caption := 'z'#322'/rok';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := 11;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [];
    WebLabel7.ParentFont := False;
    WebLabel8.SetParentComponent(WebGroupBox1);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 473;
    WebLabel8.Top := 43;
    WebLabel8.Width := 34;
    WebLabel8.Height := 11;
    WebLabel8.Caption := 'kWh/rok';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := 11;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.ParentFont := False;
    WebLabel9.SetParentComponent(WebGroupBox1);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 588;
    WebLabel9.Top := 42;
    WebLabel9.Width := 17;
    WebLabel9.Height := 11;
    WebLabel9.Caption := 'PLN';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := 11;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [];
    WebLabel9.ParentFont := False;
    WebLabel10.SetParentComponent(WebGroupBox1);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 165;
    WebLabel10.Top := 43;
    WebLabel10.Width := 39;
    WebLabel10.Height := 11;
    WebLabel10.Caption := 'kWh/kWp';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := 11;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [];
    WebLabel10.ParentFont := False;
    WebLabel11.SetParentComponent(WebGroupBox1);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 279;
    WebLabel11.Top := 43;
    WebLabel11.Width := 34;
    WebLabel11.Height := 11;
    WebLabel11.Caption := 'kWh/rok';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := 11;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [];
    WebLabel11.ParentFont := False;
    WebLabel12.SetParentComponent(WebGroupBox1);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 730;
    WebLabel12.Top := -2;
    WebLabel12.Width := 64;
    WebLabel12.Height := 16;
    WebLabel12.Caption := 'Cena Konst';
    WebLabel12.Visible := False;
    WebLabel13.SetParentComponent(WebGroupBox1);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 109;
    WebLabel13.Top := 2;
    WebLabel13.Width := 35;
    WebLabel13.Height := 16;
    WebLabel13.Caption := 'Modu'#322;
    WebLabel13.Visible := False;
    WebLabel14.SetParentComponent(WebGroupBox1);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 276;
    WebLabel14.Top := 1;
    WebLabel14.Width := 49;
    WebLabel14.Height := 16;
    WebLabel14.Caption := 'Inwerter';
    WebLabel14.Visible := False;
    WebLabel15.SetParentComponent(WebGroupBox1);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 434;
    WebLabel15.Top := 2;
    WebLabel15.Width := 28;
    WebLabel15.Height := 16;
    WebLabel15.Caption := 'Dach';
    WebLabel15.Visible := False;
    WebLabel16.SetParentComponent(WebGroupBox1);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 730;
    WebLabel16.Top := 49;
    WebLabel16.Width := 55;
    WebLabel16.Height := 16;
    WebLabel16.Caption := 'Instalacja';
    WebLabel16.Visible := False;
    WebLabel17.SetParentComponent(WebGroupBox1);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 846;
    WebLabel17.Top := 52;
    WebLabel17.Width := 59;
    WebLabel17.Height := 16;
    WebLabel17.Caption := 'Orientacja';
    WebLabel17.Visible := False;
    WebLabel18.SetParentComponent(WebGroupBox1);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 845;
    WebLabel18.Top := -2;
    WebLabel18.Width := 55;
    WebLabel18.Height := 16;
    WebLabel18.Caption := 'Po'#322'o'#380'enie';
    WebLabel18.Visible := False;
    WebLabel19.SetParentComponent(WebGroupBox1);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 851;
    WebLabel19.Top := 14;
    WebLabel19.Width := 34;
    WebLabel19.Height := 16;
    WebLabel19.Caption := 'Modul';
    WebLabel19.Visible := False;
    WebLabel20.SetParentComponent(WebGroupBox1);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 846;
    WebLabel20.Top := 36;
    WebLabel20.Width := 45;
    WebLabel20.Height := 16;
    WebLabel20.Caption := 'Inverter';
    WebLabel20.Visible := False;
    WebLabel21.SetParentComponent(WebGroupBox1);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 570;
    WebLabel21.Top := 2;
    WebLabel21.Width := 39;
    WebLabel21.Height := 16;
    WebLabel21.Caption := 'Rodzaj';
    WebLabel21.Visible := False;
    WebLabel22.SetParentComponent(WebGroupBox1);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 731;
    WebLabel22.Top := 15;
    WebLabel22.Width := 68;
    WebLabel22.Height := 16;
    WebLabel22.Caption := 'Cena modul';
    WebLabel22.Visible := False;
    WebLabel23.SetParentComponent(WebGroupBox1);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 729;
    WebLabel23.Top := 33;
    WebLabel23.Width := 65;
    WebLabel23.Height := 16;
    WebLabel23.Caption := 'Cena inwer';
    WebLabel23.Visible := False;
    WebLabel24.SetParentComponent(WebGroupBox1);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 200;
    WebLabel24.Top := 19;
    WebLabel24.Width := 18;
    WebLabel24.Height := 16;
    WebLabel24.Caption := 'K'#261't';
    WebLabel24.Visible := False;
    WebLabel25.SetParentComponent(WebGroupBox1);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 137;
    WebLabel25.Top := 21;
    WebLabel25.Width := 40;
    WebLabel25.Height := 16;
    WebLabel25.Caption := 'Cena e';
    WebLabel25.Visible := False;
    txtSampleText.SetParentComponent(WebGroupBox1);
    txtSampleText.Name := 'txtSampleText';
    txtSampleText.Left := 10;
    txtSampleText.Top := 39;
    txtSampleText.Width := 97;
    txtSampleText.Height := 20;
    txtSampleText.Color := 16777200;
    txtSampleText.Enabled := False;
    txtSampleText.Text := '-';
    WebEdit1.SetParentComponent(WebGroupBox1);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 110;
    WebEdit1.Top := 39;
    WebEdit1.Width := 51;
    WebEdit1.Height := 20;
    WebEdit1.ChildOrder := 7;
    WebEdit1.Color := 16777200;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '-';
    WebEdit2.SetParentComponent(WebGroupBox1);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 231;
    WebEdit2.Top := 39;
    WebEdit2.Width := 45;
    WebEdit2.Height := 20;
    WebEdit2.ChildOrder := 7;
    WebEdit2.Color := 16777200;
    WebEdit2.Enabled := False;
    WebEdit2.Text := '-';
    WebEdit3.SetParentComponent(WebGroupBox1);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 334;
    WebEdit3.Top := 39;
    WebEdit3.Width := 43;
    WebEdit3.Height := 20;
    WebEdit3.ChildOrder := 7;
    WebEdit3.Color := 16777200;
    WebEdit3.Enabled := False;
    WebEdit3.Text := '-';
    WebEdit4.SetParentComponent(WebGroupBox1);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 416;
    WebEdit4.Top := 39;
    WebEdit4.Width := 52;
    WebEdit4.Height := 20;
    WebEdit4.ChildOrder := 7;
    WebEdit4.Color := 16777200;
    WebEdit4.Enabled := False;
    WebEdit4.Text := '-';
    WebEdit5.SetParentComponent(WebGroupBox1);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 523;
    WebEdit5.Top := 39;
    WebEdit5.Width := 59;
    WebEdit5.Height := 20;
    WebEdit5.ChildOrder := 7;
    WebEdit5.Color := 16777200;
    WebEdit5.Enabled := False;
    WebEdit5.Text := '-';
    WebEdit6.SetParentComponent(WebGroupBox1);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 796;
    WebEdit6.Top := -1;
    WebEdit6.Width := 49;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 17;
    WebEdit6.Text := '370';
    WebEdit6.Visible := False;
    WebEdit7.SetParentComponent(WebGroupBox1);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 796;
    WebEdit7.Top := 49;
    WebEdit7.Width := 49;
    WebEdit7.Height := 19;
    WebEdit7.ChildOrder := 19;
    WebEdit7.Text := '0';
    WebEdit7.Visible := False;
    WebEdit8.SetParentComponent(WebGroupBox1);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 903;
    WebEdit8.Top := 46;
    WebEdit8.Width := 69;
    WebEdit8.Height := 19;
    WebEdit8.ChildOrder := 20;
    WebEdit8.Text := '-';
    WebEdit8.Visible := False;
    WebEdit9.SetParentComponent(WebGroupBox1);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 903;
    WebEdit9.Top := -2;
    WebEdit9.Width := 69;
    WebEdit9.Height := 19;
    WebEdit9.ChildOrder := 21;
    WebEdit9.Text := '-';
    WebEdit9.Visible := False;
    WebEdit10.SetParentComponent(WebGroupBox1);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 903;
    WebEdit10.Top := 16;
    WebEdit10.Width := 28;
    WebEdit10.Height := 19;
    WebEdit10.ChildOrder := 22;
    WebEdit10.Text := '0';
    WebEdit10.Visible := False;
    WebEdit11.SetParentComponent(WebGroupBox1);
    WebEdit11.Name := 'WebEdit11';
    WebEdit11.Left := 903;
    WebEdit11.Top := 35;
    WebEdit11.Width := 28;
    WebEdit11.Height := 19;
    WebEdit11.ChildOrder := 23;
    WebEdit11.Text := '0';
    WebEdit11.Visible := False;
    WebEdit12.SetParentComponent(WebGroupBox1);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 147;
    WebEdit12.Top := 1;
    WebEdit12.Width := 125;
    WebEdit12.Height := 19;
    WebEdit12.ChildOrder := 24;
    WebEdit12.Text := '-';
    WebEdit12.Visible := False;
    WebEdit13.SetParentComponent(WebGroupBox1);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 328;
    WebEdit13.Top := 1;
    WebEdit13.Width := 101;
    WebEdit13.Height := 19;
    WebEdit13.ChildOrder := 25;
    WebEdit13.Text := '-';
    WebEdit13.Visible := False;
    WebEdit14.SetParentComponent(WebGroupBox1);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 467;
    WebEdit14.Top := 1;
    WebEdit14.Width := 99;
    WebEdit14.Height := 19;
    WebEdit14.ChildOrder := 27;
    WebEdit14.Text := '-';
    WebEdit14.Visible := False;
    WebEdit16.SetParentComponent(WebGroupBox1);
    WebEdit16.Name := 'WebEdit16';
    WebEdit16.Left := 932;
    WebEdit16.Top := 16;
    WebEdit16.Width := 41;
    WebEdit16.Height := 19;
    WebEdit16.ChildOrder := 36;
    WebEdit16.Text := '0';
    WebEdit16.Visible := False;
    WebEdit17.SetParentComponent(WebGroupBox1);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 932;
    WebEdit17.Top := 35;
    WebEdit17.Width := 42;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 37;
    WebEdit17.Text := '0';
    WebEdit17.Visible := False;
    WebEdit18.SetParentComponent(WebGroupBox1);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 795;
    WebEdit18.Top := 15;
    WebEdit18.Width := 50;
    WebEdit18.Height := 19;
    WebEdit18.ChildOrder := 38;
    WebEdit18.Text := '490';
    WebEdit18.Visible := False;
    WebEdit19.SetParentComponent(WebGroupBox1);
    WebEdit19.Name := 'WebEdit19';
    WebEdit19.Left := 795;
    WebEdit19.Top := 32;
    WebEdit19.Width := 50;
    WebEdit19.Height := 19;
    WebEdit19.ChildOrder := 39;
    WebEdit19.Text := '1480';
    WebEdit19.Visible := False;
    WebEdit20.SetParentComponent(WebGroupBox1);
    WebEdit20.Name := 'WebEdit20';
    WebEdit20.Left := 223;
    WebEdit20.Top := 19;
    WebEdit20.Width := 48;
    WebEdit20.Height := 19;
    WebEdit20.ChildOrder := 43;
    WebEdit20.Text := '35';
    WebEdit20.Visible := False;
    WebEdit21.SetParentComponent(WebGroupBox1);
    WebEdit21.Name := 'WebEdit21';
    WebEdit21.Left := 172;
    WebEdit21.Top := 18;
    WebEdit21.Width := 34;
    WebEdit21.Height := 19;
    WebEdit21.ChildOrder := 44;
    WebEdit21.Text := '0';
    WebEdit21.Visible := False;
    WebBitBtn3.SetParentComponent(WebPanel1);
    WebBitBtn3.Name := 'WebBitBtn3';
    WebBitBtn3.Left := 3;
    WebBitBtn3.Top := 206;
    WebBitBtn3.Width := 114;
    WebBitBtn3.Height := 47;
    WebBitBtn3.Align := alCustom;
    WebBitBtn3.Caption := 'Lokalizacja';
    WebBitBtn3.Color := clBtnFace;
    WebBitBtn3.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn3.Glyph.png');
    WebBitBtn3.TabOrder := 1;
    SetEvent(WebBitBtn3, Self, 'OnClick', 'WebBitBtn3Click');
    WebBitBtn4.SetParentComponent(WebPanel1);
    WebBitBtn4.Name := 'WebBitBtn4';
    WebBitBtn4.Left := 117;
    WebBitBtn4.Top := 206;
    WebBitBtn4.Width := 117;
    WebBitBtn4.Height := 47;
    WebBitBtn4.Align := alCustom;
    WebBitBtn4.Caption := 'Energia';
    WebBitBtn4.Color := clBtnFace;
    WebBitBtn4.Enabled := False;
    WebBitBtn4.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn4.Glyph.png');
    WebBitBtn4.TabOrder := 2;
    WebBitBtn4.Visible := False;
    SetEvent(WebBitBtn4, Self, 'OnClick', 'WebBitBtn4Click');
    WebBitBtn5.SetParentComponent(WebPanel1);
    WebBitBtn5.Name := 'WebBitBtn5';
    WebBitBtn5.Left := 234;
    WebBitBtn5.Top := 206;
    WebBitBtn5.Width := 117;
    WebBitBtn5.Height := 47;
    WebBitBtn5.Align := alCustom;
    WebBitBtn5.Caption := 'Obiekt';
    WebBitBtn5.Color := clBtnFace;
    WebBitBtn5.Enabled := False;
    WebBitBtn5.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn5.Glyph.png');
    WebBitBtn5.TabOrder := 3;
    WebBitBtn5.Visible := False;
    SetEvent(WebBitBtn5, Self, 'OnClick', 'WebBitBtn5Click');
    WebBitBtn6.SetParentComponent(WebPanel1);
    WebBitBtn6.Name := 'WebBitBtn6';
    WebBitBtn6.Left := 351;
    WebBitBtn6.Top := 206;
    WebBitBtn6.Width := 117;
    WebBitBtn6.Height := 47;
    WebBitBtn6.Align := alCustom;
    WebBitBtn6.Caption := 'Instalacja';
    WebBitBtn6.Color := clBtnFace;
    WebBitBtn6.Enabled := False;
    WebBitBtn6.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn6.Glyph.png');
    WebBitBtn6.TabOrder := 4;
    WebBitBtn6.Visible := False;
    SetEvent(WebBitBtn6, Self, 'OnClick', 'WebBitBtn6Click');
    WebBitBtn7.SetParentComponent(WebPanel1);
    WebBitBtn7.Name := 'WebBitBtn7';
    WebBitBtn7.Left := 468;
    WebBitBtn7.Top := 206;
    WebBitBtn7.Width := 116;
    WebBitBtn7.Height := 47;
    WebBitBtn7.Align := alCustom;
    WebBitBtn7.Caption := 'Raport';
    WebBitBtn7.Color := clBtnFace;
    WebBitBtn7.Enabled := False;
    WebBitBtn7.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn7.Glyph.png');
    WebBitBtn7.TabOrder := 5;
    WebBitBtn7.Visible := False;
    SetEvent(WebBitBtn7, Self, 'OnClick', 'WebBitBtn7Click');
    WebBitBtn8.SetParentComponent(WebPanel1);
    WebBitBtn8.Name := 'WebBitBtn8';
    WebBitBtn8.Left := 584;
    WebBitBtn8.Top := 206;
    WebBitBtn8.Width := 117;
    WebBitBtn8.Height := 47;
    WebBitBtn8.Align := alCustom;
    WebBitBtn8.Caption := 'Finanse';
    WebBitBtn8.Color := clBtnFace;
    WebBitBtn8.Enabled := False;
    WebBitBtn8.Glyph.LoadFromFile('uFrmMain.WebPanel1.WebBitBtn8.Glyph.png');
    WebBitBtn8.TabOrder := 6;
    WebBitBtn8.Visible := False;
    SetEvent(WebBitBtn8, Self, 'OnClick', 'WebBitBtn8Click');
    WebEdit15.SetParentComponent(WebPanel1);
    WebEdit15.Name := 'WebEdit15';
    WebEdit15.Left := 613;
    WebEdit15.Top := 127;
    WebEdit15.Width := 114;
    WebEdit15.Height := 19;
    WebEdit15.ChildOrder := 8;
    WebEdit15.Text := '-';
    WebEdit15.Visible := False;
    WebButton1.SetParentComponent(WebPanel1);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 758;
    WebButton1.Top := 206;
    WebButton1.Width := 67;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 9;
    WebButton1.Visible := False;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebSplitter1.SetParentComponent(Self);
    WebSplitter1.Name := 'WebSplitter1';
    WebSplitter1.Left := 976;
    WebSplitter1.Top := 0;
    WebSplitter1.Width := 1;
    WebSplitter1.Height := 289;
    WebSplitter1.Align := alNone;
    WebSplitter1.ChildOrder := 3;
    WebSplitter1.Color := clBtnFace;
  finally
    HostPanel.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    txtSampleText.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit11.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebEdit16.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit19.AfterLoadDFMValues;
    WebEdit20.AfterLoadDFMValues;
    WebEdit21.AfterLoadDFMValues;
    WebBitBtn3.AfterLoadDFMValues;
    WebBitBtn4.AfterLoadDFMValues;
    WebBitBtn5.AfterLoadDFMValues;
    WebBitBtn6.AfterLoadDFMValues;
    WebBitBtn7.AfterLoadDFMValues;
    WebBitBtn8.AfterLoadDFMValues;
    WebEdit15.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebSplitter1.AfterLoadDFMValues;
  end;
end;

end.
